/**
 * @generated SignedSource<<331796906f22d8aeb0e9e382ad6e8293>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefetchContainer_shippingFilters$data = ReadonlyArray<{
  readonly totalCount: number | null;
  readonly " $fragmentType": "SbSharedRefetchContainer_shippingFilters";
}>;
export type SbSharedRefetchContainer_shippingFilters$key = ReadonlyArray<{
  readonly " $data"?: SbSharedRefetchContainer_shippingFilters$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefetchContainer_shippingFilters">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SbSharedRefetchContainer_shippingFilters",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    }
  ],
  "type": "ShippingFilterType",
  "abstractKey": null
};

(node as any).hash = "d5ad44746e573a35fa3db0693e7d384d";

export default node;
